import * as React from 'react';
import {Box, Typography} from "@mui/material";
import {useStyles} from "../Style";
import {getNomElection} from "../Utils";
import Synthese from "../soufflets/Synthese";
import MapEpci from "../soufflets/final/maps/MapEpci";
import SouffletsAnalyse from "../soufflets/final/SouffletsAnalyse";
import SyntheseMain from "../soufflets/SyntheseMain";


export default function Page1({
                                  electionType,
                                  resultsSynthese,
                                  codeInsee,
                                  geomEpci,
                                  resultsOfEpcis,
                                  datesByElection,
                                  mappingBvArrondissement,
                                  resultsParDonneesInseeCommune,
                                  resultsCommune,
                                  resultsParCandidatsNuancesCommune,
                                  resultsGeomIrisByBvsSynthese,
                                  otherResults

                              }) {
    console.log(otherResults);


    return (
        <Box sx={{
            width: "calc(100% - 60px)",
            display: "flex", flexDirection: "column", overflow: "auto",

            padding: "30px 30px 200px 30px",

            alignItems: "flex-start",
            gap: "50px",
            flexShrink: 0
        }}>

            <Typography
                sx={{
                    color: "#000",
                    fontSize: "20px",
                    fontStyle: "normal",
                    fontWeight: "700",
                    lineHeight: "32px"
                }}>
                Résumé des résultats des 3 dernières élections {getNomElection[electionType]}
            </Typography>
            <SyntheseMain results={resultsSynthese} codeInsee={codeInsee} electionType={electionType}/>
            <Box sx={{width: "90%",}}>
                <Typography
                    sx={{
                        color: "#000",
                        fontSize: "20px",
                        fontStyle: "normal",
                        fontWeight: "700",
                        lineHeight: "32px"
                    }}>
                    Situation de la commune au sein de son EPCI
                </Typography>
                <MapEpci
                    geomEpci={geomEpci}
                    resultsOfEpcis={resultsOfEpcis}
                    year={datesByElection[electionType].max}
                    codeInsee={codeInsee}
                    visible={true}
                    mappingBvArrondissement={mappingBvArrondissement}
                />
            </Box>
            <Box sx={{width: "98%",}}>
            <SouffletsAnalyse
                data={resultsParDonneesInseeCommune}
                resultats={resultsCommune}
                resultsParCandidatsNuancesCommune={resultsParCandidatsNuancesCommune}
                showPersonae={true}
                resultsGeomIrisByBvsSynthese={resultsGeomIrisByBvsSynthese}
                otherResults={otherResults["global"]}
                showIris={false}
                bvId={"global"}
            />
            </Box>

        </Box>)
}

/*


 */
